import { useDispatch, useSelector } from "react-redux";
import { createSetBatteryAction } from "../state/reducer";
import { useDedupEffect } from "./useDedupEffect";
import { Battery, IADPState } from "../typings";
import { LoggPrefix } from "../util/constants";
const logPrefix = "[ADP Student App][BatteryServiceHook]"
export function useBatteryService() {
    const dispatch = useDispatch();
    const state = useSelector(
      (state: { rootState: IADPState }) => state.rootState
    );
  async function getBatteryLevel() {
    // @ts-ignore
    navigator.getBattery().then((battery) => {
      console.log(LoggPrefix,logPrefix,battery);
      const batteryLevel:Battery = {level:battery.level, charging:battery.charging}
      battery.onchargingchange = () => {
          console.log(LoggPrefix,logPrefix,`battery is charging: ${battery.charging}]`);
          const batteryLevel:Battery = {level:battery.level, charging:battery.charging}
         dispatch(createSetBatteryAction(batteryLevel));
       };
      battery.onlevelchange = () => {
          console.log(LoggPrefix,logPrefix,`battery level: ${battery.level * 100}]`);
          const batteryLevel:Battery = {level:battery.level, charging:battery.charging}
          dispatch(createSetBatteryAction(batteryLevel));
      };
      dispatch(createSetBatteryAction(batteryLevel));
  }); 
}
useDedupEffect(() => {
    getBatteryLevel();
  }, []);
}


